import { Controller } from "@hotwired/stimulus"

const CONVERSATION = "conversation"
const CLOSE_CONFIRMATION = "close"
const RESTART_CONFIRMATION = "restart"

export default class extends Controller {
  static targets = [
    "content",
    "closeConfirmation",
    "closeConfirmationActions",
    "restartActions",
    "restartConfirmation",
    "restartConfirmationActions"
  ]

  connect() {
    this.restartAvailable = false
    this.state = CONVERSATION
  }

  disconnect() {
    this.#setBodyOverflowHidden(false)
  }

  requestClose(event) {
    event.preventDefault()
    sidenav.close()
  }

  handleBeforeSidenavClose(event) {
    if (!document.getElementById("sidenav_content")?.contains(this.element)) return

    event.preventDefault()
    this.#render(CLOSE_CONFIRMATION)
  }

  stay() {
    this.#render(CONVERSATION)
  }

  leave() {
    sidenav.close({ force: true })
  }

  enableRestart() {
    this.restartAvailable = true
    this.#render(CONVERSATION)
  }

  requestRestart(event) {
    event.preventDefault()
    this.#render(RESTART_CONFIRMATION)
  }

  cancelRestart() {
    this.#render(CONVERSATION)
  }

  confirmRestart() {
    this.restartAvailable = false
    this.#render(CONVERSATION)
    this.dispatch("restart")
  }

  #render(state) {
    this.state = state

    const conversation = state === CONVERSATION
    const closing = state === CLOSE_CONFIRMATION
    const restarting = state === RESTART_CONFIRMATION

    this.#toggle(this.contentTarget, conversation)
    this.#toggle(this.closeConfirmationTarget, closing)
    this.#toggle(this.closeConfirmationActionsTarget, closing)
    this.#toggle(this.restartConfirmationTarget, restarting)
    this.#toggle(this.restartConfirmationActionsTarget, restarting)
    this.#toggle(
      this.restartActionsTarget,
      conversation && this.restartAvailable
    )

    this.#setBodyOverflowHidden(!conversation)
    this.#toggleFooter(!conversation || this.restartAvailable)
  }

  #toggle(element, visible) {
    element.classList.toggle("tw-hidden", !visible)
    element.classList.toggle("tw-flex", visible)
  }

  #setBodyOverflowHidden(hidden) {
    const body = this.contentTarget.closest(".sidenav-body")
    if (body) body.style.overflowY = hidden ? "hidden" : ""
  }

  #toggleFooter(visible) {
    this.restartActionsTarget
      .closest(".sidenav-footer")
      ?.classList.toggle("tw-hidden", !visible)
  }
}
